import React from "react";
//css & images
import "./Navbar.css";
import logo from "../Images/whatsapp-black-logo.svg";

const Navbar = () => {
  return (
    <div className="navbar">
      <a href="javascript:void(0)" target="_self" rel="noopener noreferrer"><img style={{ height: "32px" }} src={logo} alt="engati-logo" /></a>
      <div className="nav-links" style={{ display: "none" }}>
        <div>
          Need help?{" "}<a className="link" href="mailto:support@engati.com?subject=Facing issues with WhatsApp onboarding" target="_blank" rel="noopener noreferrer">Contact Us</a>
        </div>
        <div className="nav-links-divider"></div>
        <div>
          <a className="link" href="https://help.engati.com/" target="_blank" rel="noopener noreferrer">Resources</a>
        </div>
        <div className="nav-links-divider"></div>
        <div>
          <a className="link" href="https://app.engati.com" target="_blank" rel="noopener noreferrer">Login</a>{" "}to Engati
        </div>
      </div>
    </div >
  );
};

export default Navbar;